import React, { Component, PropTypes } from 'react'

const FIVE_MEBIBYTES = 5242880

export default class EquipmentList extends Component {
    static propTypes = {
        crew_uuid: PropTypes.string.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
    }

    _onFileChange = (e) => {
        if (e.target.files.length) {
            const file = e.target.files[0]

            if (file.size > FIVE_MEBIBYTES) {
                this.props.gearActions.uploadEquipmentListError({
                    equipment_list: [ 'The file size must be less than 5MB' ],
                })
            } else {
                this.props.gearActions.uploadEquipmentList(e.target.files[0], this.props.crew_uuid)
            }
        }
    }

    render() {
        const errors = this.props.gear.equipment_list_errors

        if (! this.props.gear.data) {
            return null
        }

        let field_errors = null

        if (errors.equipment_list) {
            field_errors = errors.equipment_list.map(
                (error, index) => <span key={ index }>{ error }<br /></span>
            )

            field_errors = (
                <div className="alert alert--error">
                    { field_errors }
                </div>
            )
        }

        let equipment_list = null

        if (this.props.gear.data.equipment_list) {
            equipment_list = (
                <a
                    className="btn btn--primary"
                    href={ this.props.gear.data.equipment_list }
                    target="_blank"
                >
                    Download equipment list
                </a>
            )
        }

        let progress = null

        // eslint-disable-next-line no-magic-numbers
        if (this.props.gear.equipment_list_upload_progress && this.props.gear.equipment_list_upload_progress < 100) {
            const style = {
                width: `${ this.props.gear.equipment_list_upload_progress }%`,
            }

            progress = (
                <div className="progress-bar">
                    <div className="progress-bar__meter" style={ style } />
                </div>
            )
        } else {
            progress = <input accept="application/pdf,image/png" onChange={ this._onFileChange } type="file" />
        }

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Equipment List
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        { field_errors }
                        { equipment_list }

                        <p>
                            If you have a list of your entire equipment package please upload here.
                            Files must be in PDF format and must not exceed 5MB in size.
                        </p>

                        { progress }
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/equipment_list.js